window.initFAQGlobalSearch ?? (() => {
    window.initFAQGlobalSearch = (section_id) => {

        const faq_search = document.querySelector('.faq-search');
        const faq_search_wrap = faq_search.querySelector('.faq-search-wrap');
        const faq_search_input = faq_search.querySelector('#faq-search');
        const faq_search_submit = faq_search.querySelector('.faq-search-btn');
        const faq_search_clear = faq_search.querySelector('.faq-search-clear');
        const faq_search_results = faq_search.querySelector('.results');
        const faq_search_no_results = faq_search.querySelector('.no-results');
        const faq_item_template = faq_search.querySelector('.template-item');
        
        let timerFAQ;

        const getFaqData = async () => {
            try {
                const response = await fetch('/pages/faq-search?view=global-faq-search-json');

                if (!response.ok) {
                    throw new Error(`FAQ request failed: ${response.status}`);
                }

                const data = await response.json();

                return data.faqs || [];

            } catch (error) {
                console.error('Unable to load FAQ data:', error);
                return [];
            }
        };

        const showFAQResults = () => {

            let finds_counter = 0;

            let searchTerm = faq_search_input.value.toLowerCase().replace(/[^\p{L}\p{N}\s-]/gu, '').trim();

            const searchWords = searchTerm
                .toLowerCase()
                .split(/\s+/)
                .filter(word => word.length > 0);

            let faqs_filtered = window.faqs_data.filter(faq => {
                const haystack = `${faq.title} ${faq.answer}`.toLowerCase();
                return searchWords.every(word => haystack.includes(word));
            });

            //console.log(faqs_filtered);

            faq_search_results.innerHTML = '';

            faqs_filtered.forEach(faq => {
                const faq_item = faq_item_template.content.cloneNode(true);

                faq_item.querySelector('.faq-title').textContent = faq.title;
                faq_item.querySelector('.faq-answer').innerHTML = faq.answer;

                faq_search_results.appendChild(faq_item);
            });

            if(faq_search_results.innerHTML == '') {
                faq_search_no_results.classList.add('active');
            } else {
                faq_search_no_results.classList.remove('active');
                //console.log('fireee event');
               
                document.dispatchEvent(new CustomEvent('faq:results-updated', {
                    detail: {
                        resultsCount: faqs_filtered.length
                    }
                }));

                clearTimeout(timerFAQ);
                timerFAQ = setTimeout(() => {
                    console.log('finished typing');
                    console.log(faq_search_input.value.trim());
                    dataLayer.push({
                        'event': 'faq_search', 
                        'search_term': faq_search_input.value.trim()
                    });	
                }, 2000);
            }
        }

        const clearFAQResults = () => {
            faq_search_input.value = '';
            faq_search_results.innerText = '';
            faq_search_no_results.classList.remove('active');
        }

        const findFAQResults = () => {
        
            if(faq_search_input.value.trim() == '') {
                clearFAQResults();
            } else {
                showFAQResults();
            }
        }

        document.addEventListener('DOMContentLoaded', async () => {
            window.faqs_data = await getFaqData();

            //console.log(faqs_data);

            faq_search_input.addEventListener('keyup', findFAQResults);
            faq_search_input.addEventListener('keyup', function (event) {
                if (event.key === 'Enter' || event.keyCode === 13) {
                    findFAQResults();
                }
            });
            faq_search_submit.addEventListener('click', findFAQResults);
            faq_search_clear.addEventListener('click', clearFAQResults);
        });

    }
})();